<div
  class="position-relative text-center w-100"
  [appStoryblok]="_editable"
  class="container py-5 justify-content-center"
  *ngIf="assets && assets?.length > 0"
>
  @defer {
  <app-carousel [selected]="_selected" [options]="options" [caretStyle]="true">
    <div
      [attr.data-id]="blok._uid"
      class="w-100 h-auto"
      *ngFor="let blok of _assets ? _assets : assets"
    >
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </div>
  </app-carousel>
  <div class="thumbs">
    <div
      class="thumb action"
      (click)="select(blok)"
      [ngClass]="{ active: _selected === blok._uid }"
      *ngFor="let blok of _assets ? _assets : assets"
    >
      <ndc-dynamic
        *ngIf="components"
        [ndcDynamicComponent]="components[blok.component]"
        [ndcDynamicInputs]="blok"
      >
      </ndc-dynamic>
    </div>
  </div>
  } @placeholder {
  <div class="bg-secondary"></div>
  }
</div>
